import {
  AUTH_LOGIN_ERROR,
  AUTH_LOGIN_LOADING,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_SIGNUP_ERROR,
  AUTH_SIGNUP_LOADING,
  AUTH_SIGNUP_SUCCESS,
  AUTH_CHECK_ERROR,
  AUTH_CHECK_LOADING,
  AUTH_CHECK_SUCCESS,
} from "./auth.types";

let initialState = {
  loading: false,
  error: false,
  errormsg: "",
  isAuth: false,
  token: localStorage.getItem("token") || "",
  successmsg: "",
  user: JSON.parse(localStorage.getItem("user")) || {},
};

export const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_LOGIN_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case AUTH_LOGIN_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errormsg: payload,
      };
    }
    case AUTH_LOGIN_SUCCESS: {
      localStorage.setItem("token", payload.token);
      localStorage.setItem("user", JSON.stringify(payload));
      return {
        ...state,
        loading: false,
        error: false,
        isAuth: true,
        errormsg: "",
        token: localStorage.getItem("token"),
        successmsg: payload.message,
        user: JSON.parse(localStorage.getItem("user")),
      };
    }
    case AUTH_LOGOUT: {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return {
        ...state,
        loading: false,
        error: false,
        isAuth: false,
        token: "",
        successmsg: "",
        user: {},
      };
    }

    case AUTH_SIGNUP_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case AUTH_SIGNUP_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errormsg: payload,
      };
    }
    case AUTH_SIGNUP_SUCCESS: {
      localStorage.setItem("token", payload.token);
      localStorage.setItem("user", JSON.stringify(payload));
      return {
        ...state,
        loading: false,
        error: false,
        isAuth: true,
        errormsg: "",
        token: localStorage.getItem("token"),
        successmsg: payload.message,
        user: JSON.parse(localStorage.getItem("user")),
      };
    }
    case AUTH_CHECK_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case AUTH_CHECK_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errormsg: payload,
      };
    }
    case AUTH_CHECK_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        isAuth: false,
        errormsg: "",
        successmsg: payload,
      };
    }
    default: {
      return state;
    }
  }
};
